import { defineFcm } from '../shared/factory';

export const FCM_TOPIC_CLASSIFIER_SERVICE_AUTO_TRIGGER_ENABLED = defineFcm(
	'topic_classifier_service_auto_trigger_enabled',
)
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-data-ai-enablement',
		scope: 'petition-service',
		context: 'petition_service',
		description: 'Enables automatic addition of AI recommended topics on petitions',
		import: false,
		deprecated: 'FCM no longer in use — safe to delete after 2026-06-30',
	});
